/**
 *
 * @module accountManagerConfiguration
 *
 */

import ServiceConfiguration from './serviceConfiguration';

/**
 *
 * @class AccountManagerConfiguration
 *
 */
export default class AccountManagerConfiguration extends ServiceConfiguration {}



// WEBPACK FOOTER //
// ./src/services/configuration/accountManagerConfiguration.js